<div
  class="flex rounded-md bg-surface outline-1 -outline-offset-1 outline-outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-primary dark:bg-surface-darkmode dark:outline-outline-darkmode dark:has-[input:focus-within]:outline-primary-darkmode"
>
  <div class="grid shrink-0 grid-cols-1 focus-within:relative">
    <select
      class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-surface py-1.5 pr-7 pl-3 text-base text-on-surface-variant placeholder:text-on-surface-disabled focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-transparent dark:text-on-surface-variant-darkmode dark:*:bg-surface-highlight-darkmode dark:placeholder:text-on-surface-variant-darkmode dark:focus:outline-primary-highlight"
      [disabled]="disabled()"
      (change)="updateSelectValue($any($event).target.value)"
      (blur)="touched.set(true)"
      [attr.aria-label]="countryCodeLabel()"
      [attr.id]="selectId()"
    >
      @for (option of countryCodes(); track option) {
        <option [value]="option" [selected]="internalData().selectValue === option">
          {{ option }}
        </option>
      }
    </select>
    <ng-icon
      name="heroChevronDown"
      size="16"
      slot="start"
      class="!block pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-on-surface-variant sm:size-4 dark:text-on-surface-variant-darkmode"
    />
  </div>
  <input
    type="text"
    inputmode="tel"
    [attr.id]="inputId()"
    [placeholder]="placeholder()"
    [autocomplete]="autocomplete()"
    [disabled]="disabled()"
    [value]="displayTextInputValue()"
    [uiDebounce]="debounceMs()"
    (input)="displayTextInputValue.set($any($event).target.value)"
    (debouncedInput)="updateTextInputValue($event)"
    (change)="onTextInputChange($any($event).target.value)"
    (blur)="touched.set(true)"
    class="block min-w-0 grow bg-surface py-1.5 pr-3 pl-1 text-base text-on-surface placeholder:text-on-surface-disabled focus:outline-none sm:text-sm/6 dark:bg-transparent dark:text-on-surface-darkmode dark:placeholder:text-on-surface-disabled-darkmode"
  />
</div>
